import * as React from 'react';

import { UitkText } from 'uitk-react-text';

export interface HighightedPropertyDetailsProps {
  propertyDetails?: string[];
}

export const HighightedPropertyDetails: React.FunctionComponent<HighightedPropertyDetailsProps> = ({ propertyDetails }) => {
  if (!propertyDetails) {
    return null;
  }

  return (
    <>
      {propertyDetails.map((detail, index) => (
        <UitkText
          className="listing__highlighted-detail"
          size={300}
          theme="default"
          overflow="truncate"
          data-stid={`content-hotel-highlighted-detail-${index}`}
          key={`content-hotel-highlighted-detail-${index}`}
        >
          {detail}
        </UitkText>
      ))}
    </>
  );
};
HighightedPropertyDetails.displayName = 'HighightedPropertyDetails';
